function handleScrollToTopBtn(isPage2Position, yPositionToShowBtn) {
	window.addEventListener('scroll', () => handleScrollPosition(isPage2Position, yPositionToShowBtn));
	const scrollToTopBtn = document.querySelector('.scroll-to-top-btn-hover');
	scrollToTopBtn?.addEventListener('click', () =>
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		})
	);
}

function handleScrollPosition(isPage2Position, yPositionToShowBtn) {
	yPositionToShowBtn = isPage2Position ? parseFloat(page2ScrollPosition) : parseFloat(yPositionToShowBtn);
	if(!yPositionToShowBtn) {
		return;
	}
	const currentScrollPosition = window.scrollY;
	const scrollToTopBtn = document.querySelector('.scroll-to-top-btn');
	const scrollToTopHoverBtn = document.querySelector('.scroll-to-top-btn-hover');

	if (!scrollToTopBtn || !scrollToTopHoverBtn) {
		return;
	}

	// The scroll is above y position
	if (currentScrollPosition <= yPositionToShowBtn) {
		!scrollToTopBtn.classList.contains('hidden') && scrollToTopBtn.classList.add('hidden');
		!scrollToTopHoverBtn.classList.contains('hidden') && scrollToTopHoverBtn.classList.add('hidden');
		return;
	}
	if (yPositionToShowBtn && currentScrollPosition > yPositionToShowBtn) {
		scrollToTopBtn.classList.contains('hidden') && scrollToTopBtn.classList.remove('hidden');
		scrollToTopHoverBtn.classList.contains('hidden') && scrollToTopHoverBtn.classList.remove('hidden');
	}
}